import { Fragment } from "react";

import RatingBlock from "./RatingBlock";
import T from "../translations/Translations";
import { RATING_DISPLAY_LABELS } from "../../utils/teacher/InputRatingUtils";

const Legend = () => {
    const allRatingLabels = Object.keys(RATING_DISPLAY_LABELS);
    const ratingLabels = allRatingLabels.filter((label) => label.toUpperCase() !== "EXCLUDED");
    const ratingDescriptions = ["About_Exceeds", "About_Meets", "About_Approaching", "About_Does_Not_Meet"];

    return (
        <div className="legend-container">
            <div className="legend-title">{T({ key: "About_Epr" })}</div>
            <div className="legend-body">{T({ key: "About_Based" })}</div>
            <div className="row-container">
                {ratingLabels.map((label, index) => (
                    <Fragment key={`legend-row-${index}`}>
                        {index > 0 && <hr />}
                        <div key={`legend-${label}`} className="legend-row">
                            <div className="legend-left-side">{T({ key: ratingDescriptions[index] })}</div>
                            <div className="legend-right-side">
                                <RatingBlock rating={label} />
                            </div>
                        </div>
                    </Fragment>
                ))}
            </div>
        </div>
    );
};

export default Legend;
